import { ISearchState, IStateRejected, ISearchStateFulfilled } from '../../interfaces';
import { searchAction } from '../actions';

const getMatches = () => {
  const { pending, fulfilled, rejected } = searchAction.getMatches;
  return {
    // Pending
    [pending.type]: (state: ISearchState): ISearchState => ({
      ...state,
      status: 'loading',
      error: '',
    }),
    // Fulfilled
    [fulfilled.type]: (_: ISearchState, action: ISearchStateFulfilled): ISearchState => ({
      status: 'success',
      categories: action.payload.categories,
      options: action.payload.options,
      faqs: action.payload.faqs,
      suboptions: action.payload.suboptions,
      error: '',
    }),
    // Rejected
    [rejected.type]: (_: ISearchState, action: IStateRejected): ISearchState => ({
      categories: [],
      options: [],
      faqs: [],
      suboptions: [],
      status: 'error',
      error: action.error.message,
    }),
  };
};

export default {
  ...getMatches(),
};
